module.exports = __webpack_public_path__ + "static/media/view5.4d28822e.jpg";